export default __webpack_public_path__ + "static/media/edit-icon.58bb123b.svg";